import { isMobile } from "react-device-detect";
import cx from "classnames";

// Components
import Chip from "../../Chip/ChipContainer";

// CSS
import styles from "../header.module.scss";

export const HeaderFilterTags = (props) => {
    const {
        handleSelectTag,
        mappedFilters,
        selectedTags,
        shouldHideHeader,
        shouldShowFilterTags,
        toggleFilterTagsDisplay,
    } = props;

    /**
     * Constants
     */

    const categoryFilters = mappedFilters?.find(
        ({ type }) => type === "categories"
    )?.items;
    const conferenceFilters = mappedFilters?.find(
        ({ type }) => type === "conferences"
    )?.items;

    /**
     * End Hooks
     */

    function onMouseLeave() {
        if (!isMobile) {
            toggleFilterTagsDisplay(false);
        }
    }

    function renderCategoryFilters() {
        return categoryFilters?.map((tag, i) => {
            const isAlreadySelected = selectedTags.some(
                (selectedTag) => selectedTag.tag === tag.tag
            );
            return (
                <Chip
                    isSelected={isAlreadySelected}
                    key={i}
                    onClick={() => handleSelectTag(tag, "categories")}
                    text={tag.display_text}
                />
            );
        });
    }

    function renderConferenceFilters() {
        return conferenceFilters?.map((tag, i) => {
            const isAlreadySelected = selectedTags.some(
                (selectedTag) => selectedTag.tag === tag.tag
            );
            return (
                <Chip
                    isSelected={isAlreadySelected}
                    key={i}
                    onClick={() => handleSelectTag(tag, "conferences")}
                    text={tag.display_text}
                />
            );
        });
    }

    return (
        <div
            className={cx(styles.filterTags, {
                [styles["filterTags--active"]]:
                    shouldShowFilterTags && !shouldHideHeader,
            })}
            onMouseLeave={onMouseLeave}
        >
            <div className={styles.filterTagsLeft}>
                {renderCategoryFilters()}
            </div>
            <div className={styles.filterTagsRight}>
                {renderConferenceFilters()}
            </div>
        </div>
    );
};
